export const styles = {
  publicAgendaCtn: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 50px",
    boxSizing: "border-box",
    width: "100%",
    gap: "20px",
  },
  closeButton: {
    background: "#eee",
    borderRadius: "10px",
    padding: "6px",
    position: "absolute",
    right: "10px",
  },
  empty: {
    color: "rgba(72, 74, 86, 0.7)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
    padding: "1.25rem",
    "& img": {
      width: "6rem",
    },
  },
  heading: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50px",
    height: "50px",
    borderRadius: "10px",
    border: "1px solid #e6e6e6",
    backgroundColor: "#f9fafc",
  },
  iconBeta: {
    // Combined with icon style or used separately if needed
    borderRadius: 0,
    border: "none",
    backgroundColor: "transparent",
    "& img": {
      width: "100%",
      height: "100%",
    },
  },
  rightCol: {
    paddingLeft: "20px",
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    "& h2": {
      // Targeting h2 specifically if Typography variant doesn't cover
      margin: 0,
      fontSize: "20px",
      lineHeight: "26px",
      color: "var(--TextDark)",
    },
  },
  descriptionText: {
    // For the Typography component with className="description"
    fontSize: "16px",
    lineHeight: "21px",
    color: "var(--TextDark)",
  },
  times: {
    display: "flex",
    flexDirection: "row",
  },
  timeItem: {
    marginRight: "66px",
  },
  timeTitle: {
    fontSize: "11px",
    lineHeight: "15px",
    color: "var(--TextDark)",
    opacity: 0.7,
  },
  timeVal: {
    fontSize: "14px",
    lineHeight: "19px",
    color: "var(--TextDark)",
  },
  divider: {
    height: "1px",
    backgroundColor: "#e6e6e6",
  },
  itemsCtn: {
    overflowY: "auto",
    maxHeight: "calc(100% - 230px)",
    paddingRight: "10px",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#e8e8e8",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#fff",
    },
  },
  daysScroller: {
    flex: "none",
  },
};
